/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { Metadata } from "next";
import { notFound } from "next/navigation";

import { ErrorTestPage } from "./ErrorTestPage.client";

export const metadata: Metadata = {
	title: "Error Test Page",
	robots: {
		index: false,
		follow: false,
	},
};

export default function CosmosErrorTestPage(): React.JSX.Element {
	// This page deliberately throws (e.g. `?type=500` → uncaught error → real SSR 500).
	// It must never be reachable on the live cluster: security scanners crawl it and
	// trigger those 500s, which pollute the ALB error-rate metric and fire the error-rate
	// alert (MW-13261). 404 it in prod; keep it on dev/local for error-handling testing.
	if (process.env.EPIC_ENV === "live") {
		notFound();
	}

	return <ErrorTestPage />;
}
